export default __webpack_public_path__ + "static/media/text.f031ab70.svg";